export default __webpack_public_path__ + "static/media/Grid3.3.f10206b2.jpg";